import { memo } from 'react'
import LogoSvg from '@svgs/MR-Recip.svg'

const Logo = () => {
  return <img src={LogoSvg} alt='Mr Recip' loading='lazy' />
}

export default memo(Logo)
